import { Button, Modal } from 'antd';
import defs from "./defs"
import { useTranslation } from 'react-i18next';

function SettingDetail (props) {
    const { t } = useTranslation();
    const {show, onClose, SettingID, SN, CreateTime, CreatorID, Data, RspData, RspTime} = props;
    //

    const hexToString = (hex) => {
        let result = '';
        for (let i = 0; i < hex.length; i += 2) {
            let byte = hex.substr(i, 2);
            let code = parseInt(byte, 16);
            if (isNaN(code)) {
                return "";
            }
            result += String.fromCharCode(code);
        }
        return result;
    }

    const setting = SettingID ? defs.setting_meta_map[SettingID*1] : null;
    let reqData = {};
    let rspData = {};
    try {
        const x = hexToString(Data);
        if (x == "") {
            reqData = JSON.parse(Data);
        } else {
            reqData = JSON.parse(x);
        }
    } catch (e) {
        //
    }
    if (! reqData) {
        reqData = {};
    }
    try {
        rspData = JSON.parse(RspData);
    } catch (e) {
        //
    }
    if (! rspData) {
        rspData = {};
    }
    if (setting) {
        if (setting.Fields.length === 1 && setting.Fields[0].DataType === "[]byte") {
            const name = setting.Fields[0].Name;
            const name2 = setting.Fields[0].Title;
            if (rspData[name].length > 0) {
                //const ss = atob(rspData[name])
                const ss = Buffer.from(rspData[name], "base64")
                let i = 0;
                ss.map((b) => {
                    for (let j=0; j<4; j++) {
                        rspData[`${name2}${i}`] = (b >> (j*2)) & 3;
                        i++;
                    }
                })
                rspData[name] = ss;
            }
        } else {
            for (let f of setting.Fields) {
                if (f.Offset) {
                    rspData[f.Name] += f.Offset;
                }
            }
        }
    }

    return (
        <Modal 
            title={t('Setting Details: {{SN}}', { SN })}
            visible={show}
            cancelText={t('Cancel')}
            okText={t('Submit')}
            mask={true}
            maskClosable={true}
            //width={600}
            onCancel={onClose}
            onOk={onClose}
            footer={[
                <Button key="Close" type="primary" onClick={onClose}>{t('Close')}</Button>
            ]}
        >
            <div style={{
                textAlign: 'center',
                fontWeight: "bold",
                paddingBottom: "10px"
            }}>
                {setting ? t(setting.Title) : ""}&nbsp;{SettingID>0x3000 ? t('Read') : t('Write')}
            </div>
            <div style={{
                paddingBottom: "10px",
                color: "#888",
            }}>
                {t('User')}: {CreatorID}, {t('Request Time')}: {CreateTime}, {t('Response Time')}: {RspTime || ""}
            </div>
            <table cellPadding="5px" width="100%" border= "1px solid, #aaa">
                <thead><tr>
                    <th>{t('Field')}</th>
                    <th>{t('Request')}</th>
                    <th>{t('Response')}</th>
                </tr></thead>
                <tbody>
                {setting ? (
                    setting.Fields.map((f) => {
                        if (setting.ReadID===0x3004) {
                            const rs = [];
                            (reqData[f.Name] || rspData[f.Name] || []).map((r, idx) => {
                                for (let j=0; j<4;j ++) {
                                    const fn = `${f.Title}${idx*4+j}`;
                                    rs.push((<tr>
                                        <td align="right">{t(f.Title)}{idx*4+j+1}:&nbsp;</td>
                                        <td>{SettingID>0x3000 ? "" : (reqData.hasOwnProperty(fn) ? defs.getValueTitle(f,reqData[fn]) : "")}</td>
                                        <td>{rspData.hasOwnProperty(fn) ? defs.getValueTitle(f, rspData[fn]) : ""}</td>
                                    </tr>));
                                }
                                
                            });

                            return rs;
                        }
                        return (<tr>
                            <td align="right">{t(f.Title)}:&nbsp;</td>
                            <td>{
                                SettingID>0x3000 ? "" : 
                                    (reqData.hasOwnProperty(f.Name) ? 
                                        defs.getValueTitle(f, reqData[f.Name])
                                        : ""
                                    )
                            }</td>
                            <td>{rspData.hasOwnProperty(f.Name) ?defs.getValueTitle(f, rspData[f.Name]) : ""}</td>
                        </tr>)
                    })
                ) : <tr></tr>}
                </tbody>
            </table>
        </Modal>
    )
}

export default SettingDetail;